export default __webpack_public_path__ + "static/media/cruptoIconSocial.0adde3cb.svg";